import "~/misc/common";
import DeviceBase from "./device_base";
import { ChartTemperature } from "./chart_temperature";
import { GaugeTemperature } from "./gauge_temperature";

export default class extends DeviceBase {
	connect() {
		const controller = this;

		this.connectBase({
			channel: "ThermometerGatewayChannel",
			onConnection: (connected) => {
				if (connected) controller.sendCmd('?');
			},
			onEvent: (msg: string) => {
				if (msg.startsWith('temp.')) {
					temperature(msg.replace('temp.', ''));
				}
				if (msg.startsWith('udp.port=')) {
					const udp_port = parseInt(msg.replace('udp.port=', ''));
					$('#state_udp_port').val(udp_port);
				}
			}
		});

		const el = this.element as HTMLDivElement;
		const thermometers = JSON.parse(el.dataset.thermometers!);
		console.log(thermometers);

		function temperature(msg: string) {
			const parts = msg.split("=");
			const temp = parseFloat(parts[1]) / 10.0;
			const mac = parts[0];
			gauges.updateGauge(mac, temp);
		}

		$('#state_udp_port').on('change', function () {
			controller.sendCmd('udp.port=' + Math.round($('#state_udp_port').myGetNumValue()!));
		});

		// TEMPERATURE GAUGE
		const gauges = new GaugeTemperature(thermometers);

		//LINE CHART
		const chart = new ChartTemperature('#line', controller.mac_address);

	}
}

//function initVirtualThermometerApp() {
//	var interval;
//	var temperature_channel = App.cable.subscriptions.create({
//		channel : "ThermometerGatewayChannel",
//		mac : 'virtual_thermometer'
//	}, {
//		connected : function() {
//			console.log('virtual_thermometer connected');
//			interval = setInterval(function() {
//				App.cable.send("pong");
//			}, 3000);
//		},
//
//		disconnected : function() {
//			console.log('virtual_thermometer disconnected');
//			clearInterval(interval);
//		},
//	});
//
//	$('form.state').submit(function() {
//		return false;
//	});
//
//	$('#state_temp').change(function() {
//		temp = $('#state_temp').myGetNumValue();
//		if (temp != null) {
//			temperature_channel.perform("event", {
//				msg : 'temp.virtual_thermometer=' + Math.round(temp * 10.0)
//			});
//		}
//	});
//
//}
